import React from "react";
import ButtonClose from "components/ButtonClose/ButtonClose";
import Logo from "components/Logo/Logo";
import { Disclosure } from "@headlessui/react";
import { NavLink } from "react-router-dom";
import { NavItemType } from "./NavigationItem";
import DarkModeContainer from "containers/DarkModeContainer/DarkModeContainer";
import { NAVIGATION_DEMO } from "data/navigation";
import {auth} from "../../configs/firebase-config";
import {signOut} from "firebase/auth";
import {useHistory} from "react-router";
import ButtonSecondary from "../Button/ButtonSecondary";
import SocialsList from "components/SocialsList/SocialsList";
import {displayToast, toastType} from "../../global/Functions";


export interface NavMobileProps {
  data?: NavItemType[];
  onClickClose?: () => void;
}

const NavMobile: React.FC<NavMobileProps> = ({
  data = NAVIGATION_DEMO,
  onClickClose,
}) => {
  const history = useHistory();

  const handleSignOut = () => {
    try{
      signOut(auth).then(() => {
        history.replace("/login");
      });
      displayToast("See you soon!", toastType.info);
    } catch (error) {
      displayToast("Something went wrong", toastType.error);
    }
  }

  const _renderMenuChild = (item: NavItemType) => {
    return (
      <ul className="nav-mobile-sub-menu pl-6 pb-1 text-base">
        {item.children?.map((i, index) => (
          <Disclosure key={i.href + index} as="li">
            {i.targetBlank ? (
              <a
                href={i.href}
                target="_blank"
                rel="noreferrer"
                className="flex px-4 py-2.5 text-neutral-900 dark:text-neutral-200 text-sm font-medium rounded-lg hover:bg-neutral-100 dark:hover:bg-neutral-800 mt-[2px]"
              >
                <span
                  className={!i.children ? "block w-full" : ""}
                  onClick={onClickClose}
                >
                  {i.name}
                  {i.isNew && (
                    <span className="bg-red-500 text-white text-[10px] px-1.5 py-0.5 leading-none rounded-md ml-2">
                      New!
                    </span>
                  )}
                </span>

                {i.children && (
                  <span
                    className="block flex-grow"
                    onClick={(e) => e.preventDefault()}
                  >
                    <Disclosure.Button
                      as="span"
                      className="flex justify-end flex-grow"
                    >

                    </Disclosure.Button>
                  </span>
                )}
              </a>
            ) : (
              <NavLink
                exact
                strict
                to={{
                  pathname: i.href || undefined,
                }}
                className="flex px-4 py-2.5 text-neutral-900 dark:text-neutral-200 text-sm font-medium rounded-lg hover:bg-neutral-100 dark:hover:bg-neutral-800 mt-[2px]"
                activeClassName="text-secondary"
              >
                <span
                  className={!i.children ? "block w-full" : ""}
                  onClick={onClickClose}
                >
                  {i.name}
                </span>
                {i.children && (
                  <span
                    className="block flex-grow"
                    onClick={(e) => e.preventDefault()}
                  >
                    <Disclosure.Button
                      as="span"
                      className="flex justify-end flex-grow"
                    >

                    </Disclosure.Button>
                  </span>
                )}
              </NavLink>
            )}
            {i.children && (
              <Disclosure.Panel>{_renderMenuChild(i)}</Disclosure.Panel>
            )}
          </Disclosure>
        ))}
      </ul>
    );
  };

  const _renderItem = (item: NavItemType, index: number) => {
    return (
      <Disclosure
        key={item.id}
        as="li"
        className="text-neutral-900 dark:text-white"
      >
        <NavLink
          exact
          strict
          className="flex w-full items-center py-2.5 px-4 font-medium uppercase tracking-wide text-sm hover:bg-neutral-100 dark:hover:bg-neutral-800 rounded-lg"
          to={{
            pathname: item.href || undefined,
          }}
          activeClassName="text-secondary"
        >
          <span
            className={!item.children ? "block w-full" : ""}
            onClick={onClickClose}
          >
            {item.name}
          </span>
          {item.children && (
            <span
              className={"block flex-grow"}
              onClick={(e) => e.preventDefault()}
            >
              <Disclosure.Button
                as="span"
                className="flex justify-end flex-grow"
              >
              </Disclosure.Button>
            </span>
          )}
        </NavLink>
        {item.children && (
          <Disclosure.Panel>{_renderMenuChild(item)}</Disclosure.Panel>
        )}
      </Disclosure>
    );
  };

  return (
    <div className="overflow-y-auto w-full max-w-sm h-screen py-2 transition transform shadow-lg ring-1 dark:ring-neutral-700 bg-white dark:bg-neutral-900 divide-y-2 divide-neutral-100 dark:divide-neutral-800">
      <div className="py-6 px-5">
        <div className="flex justify-center items-center mt-4">
          <Logo />
        </div>
        <div className="flex flex-col mt-5 text-neutral-700 dark:text-neutral-300 text-sm">
          <div className="flex justify-center items-center mt-">
            <h1 className=" font-bold text-4l md:text-xl xl:text-6xl mt-3 md:!leading-[110%] ">
              The CryptoVerse
            </h1>
          </div>
          <div className="flex justify-center items-center mt-4">
            <DarkModeContainer className="bg-neutral-100 dark:bg-neutral-800" />
          </div>
        </div>
        <div className="flex justify-center items-center mt-4">
          <SocialsList itemClass="flex justify-center items-center mt-4 w-9 h-9 flex items-center justify-center rounded-full bg-neutral-100 text-xl dark:bg-neutral-800 dark:text-neutral-300" />
        </div>
        <span className="absolute right-2 top-2 p-1">
          <ButtonClose onClick={onClickClose} />
        </span>
      </div>
      <ul className="flex justify-center items-center flex flex-col py-6 px-2 space-y-1">
        {data.map(_renderItem)}
      </ul>
        <div className="flex justify-center items-center py-6 px-5 space-x-4">
            {auth.currentUser ?
                <a href="/dashboard">
                    <ButtonSecondary>Dashboard</ButtonSecondary>
                </a>
                :
                <a href="/login">
                    <ButtonSecondary>Sign In</ButtonSecondary>
                </a>
            }

        </div>
    </div>
  );
};

export default NavMobile;
